import { render, staticRenderFns } from "./ReportDialog.vue?vue&type=template&id=51928d08&scoped=true"
import script from "./ReportDialog.vue?vue&type=script&lang=js"
export * from "./ReportDialog.vue?vue&type=script&lang=js"
import style0 from "./ReportDialog.vue?vue&type=style&index=0&id=51928d08&prod&lang=css"
import style1 from "./ReportDialog.vue?vue&type=style&index=1&id=51928d08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@osgfe/builder-plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51928d08",
  null
  
)

export default component.exports